export default "__VITE_ASSET__nKs9RTQX__"